import Component from '@bythepixel/component-loader';
import DEFAULTS from '@Front/components/specs/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class Accordion extends Component {
  static selector = `[${DEFAULTS.specs}]`;

  constructor(containerEl, options = { ...DEFAULTS }) {
    super(containerEl, options);

    this.specs = this.$container;
    this.container = this.specs.querySelector(`[${this.$options.container}]`);
    this.trigger = this.specs.querySelector(`[${this.$options.trigger}]`);

    handleComponentError([
      [!this.container, 'Specifications element has no scroll container.'],
      [!this.trigger, 'Specifications container element has no trigger.'],
    ]);

    this.mount();
  }

  mount() {
    this.trigger.addEventListener('click', () => {
      this.toggleSpecs();
    });

    // Reset overflow to allow for the closing animation and sticky headings
    this.specs.addEventListener('transitionend', (event) => {
      if (event.propertyName !== 'grid-template-rows' || !this.isOpenState()) {
        return;
      }

      this.setOverflow('unset');
    });
  }

  getState() {
    return this.specs.getAttribute(this.$options.state);
  }

  isOpenState() {
    return this.getState() === 'open';
  }

  setOverflow(value) {
    this.container.style.overflow = value;
  }

  toggleSpecs() {
    if (this.isOpenState()) {
      this.setOverflow('hidden');
    }

    this.specs.setAttribute(this.$options.state, this.isOpenState() ? 'closed' : 'open');
    this.trigger.setAttribute('aria-expanded', this.isOpenState());
  }
}
